const APIDocumentationRoutes = [
  {
    path: '/api/get-started',
    name: 'Get Started',
    component: () => import('@/views/api_documentation/GetStarted.vue')
  },
  {
    path: '/api/get-access-token',
    name: 'Get Access Token',
    component: () => import('@/views/api_documentation/GetAccessToken.vue')
  },
  {
    path: '/api/generate-mandate-token',
    name: 'Generate Mandate Token',
    component: () => import('@/views/api_documentation/GenerateMandateToken.vue')
  },
  {
    path: '/api/batch-uploads',
    name: 'Batch Uploads',
    component: () => import('@/views/api_documentation/BatchUploads.vue')
  },
  // {
  //   path: '/api/get-batch-upload-status',
  //   name: 'Get Batch Upload Status',
  //   component: () => import('@/views/api_documentation/GetBatchUploadStatus.vue')
  // },
  // {
  //   path: '/api/get-pending-approval-batch',
  //   name: 'Get Pending Approval Batch',
  //   component: () => import('@/views/api_documentation/GetPendingApprovalBatch.vue')
  // },
  {
    path: '/api/get-transaction',
    name: 'Get Transaction',
    component: () => import('@/views/api_documentation/GetTransaction.vue')
  },
  {
    path: '/api/get-batch-transaction',
    name: 'Get Batch Transaction',
    component: () => import('@/views/api_documentation/GetBatchTransaction.vue')
  }
]

export default APIDocumentationRoutes
